const meta = {
  module: "users"
};

export default [
  {
    path: `/users`,
    redirect: "/users/page/1"
  },
  {
    path: `/users/page`,
    redirect: "/users/page/1"
  },
  {
    path: `/users/page/:page`,
    name: "users",
    component: () =>
      import(/* webpackChunkName: "users" */ "@/modules/users/views/index.vue"),
    meta: {
      ...meta
    }
  },
  {
    path: `/users/create`,
    name: "users/create",
    component: () =>
      import(
        /* webpackChunkName: "roles/edit" */ "@/modules/users/views/create.vue"
      ),
    meta: {
      ...meta,
      action: "create"
    }
  },
  {
    path: `/users/edit/:id`,
    name: "users/edit",
    component: () =>
      import(
        /* webpackChunkName: "roles/edit" */ "@/modules/users/views/edit.vue"
      ),
    meta: {
      ...meta,
      action: "create"
    }
  },
  {
    path: `/users/upload-documents`,
    name: "users/upload-documents",
    component: () =>
      import(
        /* webpackChunkName: "roles/edit" */ "@/modules/users/views/upload-documents.vue"
      ),
    meta: {
      ...meta,
      action: "edit"
    }
  },
  {
    path: `/activity-log`,
    redirect: "/activity-log/page/1"
  },
  {
    path: `/activity-log/page`,
    redirect: "/activity-log/page/1"
  },
  {
    path: `/activity-log/page/:page`,
    name: "activity-log",
    component: () =>
      import(
        /* webpackChunkName: "roles/edit" */ "@/modules/users/views/activity-log.vue"
      ),
    meta: {
      ...meta,
      module: "activity-log",
      action: "list"
    }
  }
];
